import TextBox from '../../TextBox';
import { IInputChangeEventArgs } from '@bimser/components';
export interface ITextBoxProps {
	onValueChange: (data: string) => void;
}
export default class OvverideTextBox extends TextBox {
	readonly props: ITextBoxProps;
	constructor(props?: ITextBoxProps) {
		super();
		this.props = props;
	}
	triggerValueChanged(args: IInputChangeEventArgs) {
		if (this.props.onValueChange) {
			this.props.onValueChange(args.data);
		}
	}
}
